import React from "react";
import { wrapCollectionLayout } from "@quintype/components";
import { StoryCard } from "../basic/story-card.js";
import get from "lodash/get";
import { CollectionName } from "../atoms/collection-name/index.js";
import "./two-col-highlight.module.css";
import { isEager, getRowMetadata } from "../../utils";
import PropTypes from "prop-types";

function TwoColHighlightBase({ stories = [], metadata = {}, collection, associatedMetadata, index, config }) {
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  const length = stories ? stories.length : 0;

  const imageConfig = {
    image: true,
    imageAspectRatio: [4, 3],
    imageWidth: [400, 300]
  };
  const smallImageConfig = {
    image: true,
    imageAspectRatio: [4, 3],
    imageWidth: [250, 300]
  };
  const story = get(stories, [0], {});

  if (length < 4) {
    return <div data-comment="At least four stories required for a TwoColHighlight" />;
  }
  const { show_collection_title: collectionName = true } = pbAheadConfig;
  return (
    <div styleName="component-wrapper" data-test-id="two-col-highlight-component">
      {collectionName ? <CollectionName name={collection.name} config={config} section={collection} /> : null}
      <div styleName="container">
        <div styleName="story-with-highlighted-card fix-height">
          <StoryCard
            config={imageConfig}
            pickOfTheDay={true}
            story={story}
            hideSectionName={true}
            titleofTheHighlightedStory={pbAheadConfig.titleofTheHighlightedStory}
            eager={isEager(index, true)}
          />
        </div>
        <div styleName="story-with-card fix-height">
          {stories.slice(1, 4).map(story => {
            return (
              <StoryCard
                eager={isEager(index)}
                key={story.id}
                story={story}
                hideSectionName={true}
                config={smallImageConfig}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
TwoColHighlightBase.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  metadata: PropTypes.object,
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object,
  index: PropTypes.number
};

export const TwoColHighlight = wrapCollectionLayout(TwoColHighlightBase);
